export default {"src":"/_next/static/media/icon-sell.2ce3da1a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};